import React from 'react';
import { Clock, LogOut, ShieldAlert } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { Button } from '../components/ui/button';
import { cn } from '../lib/utils';

export default function PendingAccess() {
  const { user, logout } = useAuth();
  const { theme } = useTheme();

  return (
    <div className={cn(
      "min-h-screen flex items-center justify-center p-6",
      theme === 'dark' ? 'bg-[#050505]' : 'bg-gray-50'
    )}>
      <div className={cn(
        "w-full max-w-lg p-8 rounded-2xl border text-center",
        theme === 'dark' ? 'bg-zinc-900/80 border-white/10' : 'bg-white border-gray-200 shadow-lg'
      )} data-testid="pending-access-page">
        {/* Icon */}
        <div className={cn(
          "w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6",
          theme === 'dark' ? 'bg-amber-500/15' : 'bg-amber-100'
        )}>
          <Clock size={40} className="text-amber-500" />
        </div>

        {/* Title */}
        <h1 className={cn(
          "text-2xl font-bold mb-3",
          theme === 'dark' ? 'text-white' : 'text-gray-900'
        )}>
          En attente de permissions
        </h1>

        {/* Message */}
        <p className={cn(
          "text-base mb-6 leading-relaxed",
          theme === 'dark' ? 'text-zinc-400' : 'text-gray-600'
        )}>
          Vous aurez accès au site une fois qu'un administrateur aura validé votre accès.
        </p>

        {/* Info box */}
        <div className={cn(
          "p-4 rounded-xl border mb-8",
          theme === 'dark' ? 'bg-zinc-800/50 border-white/5' : 'bg-gray-50 border-gray-200'
        )}>
          <div className="flex items-center gap-3 justify-center">
            <ShieldAlert size={18} className={theme === 'dark' ? 'text-zinc-500' : 'text-gray-400'} />
            <p className={cn(
              "text-sm",
              theme === 'dark' ? 'text-zinc-500' : 'text-gray-500'
            )}>
              Connecté en tant que <span className={cn("font-semibold", theme === 'dark' ? 'text-zinc-300' : 'text-gray-700')}>{user?.prenom} {user?.nom}</span>
            </p>
          </div>
        </div>

        {/* Logout */}
        <Button
          onClick={logout}
          variant="outline"
          className={cn(
            "h-11 px-6",
            theme === 'dark' ? 'bg-zinc-800 border-white/10 text-white hover:bg-white/10' : 'border-gray-300 text-gray-700 hover:bg-gray-100'
          )}
          data-testid="pending-logout-button"
        >
          <LogOut size={18} className="mr-2" />
          Se déconnecter
        </Button>
      </div>
    </div>
  );
}
